import { AlertsAppView } from '../view/AlertsAppView';
import { templateAlertsApp } from '../view/template';
import { AlertsAppRepository } from '../repository/AlertsAppRepository';
import { BaseWebComponentController } from '../../framework/BaseWebComponentController';
import { AlertsAppWebComponent } from '..';
import { AlertsAppData } from '../types';

export class AlertsAppController extends BaseWebComponentController {
  public component: AlertsAppWebComponent;
  public dataRepository: AlertsAppRepository;
  public view: AlertsAppView;
  public viewConstructor: typeof AlertsAppView;
  public dataRepositoryConstructor: typeof AlertsAppRepository;

  constructor(component: AlertsAppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AlertsAppView,
      viewTemplate: templateAlertsApp,
      dataRepositoryConstructor: AlertsAppRepository,
    });
  }

  async getDataForView(): Promise<AlertsAppData> {
    return {
      externalParams: this.component.externalParams,
    };
  }
}
